import { type SelectDataObject } from '../_tools/inputfields/Select';

const sFdKsb: SelectDataObject[] = [
    { i: 0, t: 'kein' },
    { i: 1, t: 'KSB' },
    { i: 2, t: 'KSB Plus' },
];
export default sFdKsb;
